import gql from 'graphql-tag';

export default gql`
  mutation setAssetMissing($assetId: String!) {
    setAssetMissing(assetId: $assetId)
 }
`;